module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid', {
    attrs: {
      "name": "Programs & Events",
      "desc": "Create and manage your programs and events",
      "search": "",
      "endpoint": _vm.api.$.program.list
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a8891a2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Program-list/index.vue
// module id = 9fwx
// module chunks = 13 14